import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";

import Select from "../../../../components/Select";

export default function DesireContractType({ searchObject, onChange, t }) {
  const [contractTypes, setContractTypes] = useState([]);

  useEffect(() => {
    CommonService.getContractType().then((data) => setContractTypes(data));
  }, []);

  return (
    <div>
      <legend className="fontsize-legend">{t("Desired Contract Type")}</legend>
      <Select
        onChange={onChange}
        value={searchObject.desiredContractTypeId || ""}
        name="desiredContractTypeId"
        className="form-select fontsize-legend"
      >
        <option value=""></option>
        {contractTypes.map((contract) => (
          <option
            className="fontsize-legend"
            value={contract.id}
            key={contract.id}
          >
            {t(contract.description)}
          </option>
        ))}
      </Select>
    </div>
  );
}
